import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { DSAuthService } from '../../auth.service';
import { IdentityProvider } from '../../enums/identity-providers';

interface LoginValue {
  username: string;
  password: string;
}

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['../shared/auth-form.scss'],
})
export class LoginComponent implements OnInit {
  @Output() submitLoginFormInit: EventEmitter<LoginValue> = new EventEmitter();

  config;

  form: UntypedFormGroup;
  rememberUser: UntypedFormGroup;

  get value(): LoginValue {
    return this.form.value;
  }

  constructor(
    private router: Router,
    public authService: DSAuthService,
  ) {}

  ngOnInit() {
    if (this.authService.configuration.idp === IdentityProvider.OKTA) {
      this.router.navigate([this.authService.authUrls.okta]);
    } else {
      this.config = this.authService.configuration.login;
      this.form = new UntypedFormGroup({});
      this.rememberUser = new UntypedFormGroup({});
    }
  }

  handleLinkClick(event) {
    if (event.config.prop === 'username') {
      this.router.navigate([this.authService.authUrls.forgotUsername]);
    }

    if (event.config.prop === 'password') {
      this.router.navigate([this.authService.authUrls.forgotPassword]);
    }
  }

  submitLoginForm() {
    if (!this.form.valid) {
      Object.keys(this.form.controls).forEach((key) => {
        this.form.get(key).markAsTouched();
      });
    } else {
      this.authService.submitLogin(this.value);
    }
  }
}
